import { STRING } from './constants';

export default function isString(value) {
    return typeof value === STRING;
}